import { render, staticRenderFns } from "./SelectProvince.vue?vue&type=template&id=2710221e&scoped=true&"
import script from "./SelectProvince.vue?vue&type=script&lang=js&"
export * from "./SelectProvince.vue?vue&type=script&lang=js&"
import style0 from "./SelectProvince.vue?vue&type=style&index=0&id=2710221e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2710221e",
  null
  
)

export default component.exports